module.exports = __webpack_public_path__ + "img/logo_chateau_small.051f5c6a.png";